<template>
  <div
    v-if="menuContentHolder"
    class="container"
  >
    <template v-if="megaMenu">
      <div
        v-if="menuStyle === 'desktop'"
        class="mega-region-display"
      >
        <content-menu-mega-desktop :menu-content="menuContent['Menu Items']" />
      </div>
      <div
        v-else-if="menuStyle === 'mobile'"
        class="mega-region-display visible"
      >
        <content-menu-mega-desktop :menu-content="menuContent['Menu Items']" />
      </div>
    </template>
    <template v-else>
      <template v-if="menuStyle === 'desktop'">
        <content-menu-editor-desktop
          :menu-content="menuContent"
          :menu-direction="menuDirection"
        />
      </template>
      <template v-else-if="menuStyle === 'mobile'">
        <content-menu-editor-mobile
          :menu-content="menuContent"
        />
      </template>
    </template>
  </div>
</template>

<script>
import contentMenuEditorDesktop from '../layouts/menu-editor/content-menu-editor-desktop.vue'
import contentMenuEditorMobile from '../layouts/menu-editor/content-menu-editor-mobile.vue'
import MegaMenu from './menu/new-mega-layout'

export default {
  components: {
    'content-menu-editor-desktop': contentMenuEditorDesktop,
    'content-menu-editor-mobile': contentMenuEditorMobile,
    'content-menu-mega-desktop': MegaMenu
  },
  props: {
    'widget': {
      type: Object,
      required: true
    },
    'menuStyle': {
      type: String,
      required: true
    },
    'menuContainerEntryName': {
      type: String,
      default: ''
    },
    'menuDirection': {
      type: String,
      required: true
    },
    'menuReduce': {
      type: String,
      required: true
    },
    'menuSelection': {
      type: String,
      required: true
    }
  },
  data() {
    return {
      menuContentHolder: null
    }
  },
  computed: {
    megaMenu() {
      return this.widget.menuType === 'mega'
    },
    menuContent: function() {
      let defaultMenuContent = {
        'Menu Items': [
          {
            'type': 'container',
            'id': 1,
            'linkText': 'Container',
            'columns': [
              {
                'linkText': 'item',
                'type': 'item',
                'id': '1'
              }
            ]
          },
          {
            'linkText': 'New item',
            'type': 'item',
            'id': '2'
          }
        ]
      }
      return this.widget.menuContent || defaultMenuContent
    }
  },
  watch: {
    menuContainerEntryName: {
      handler: function() {
        if (this.menuReduce && (this.menuSelection !== '' || this.menuContainerEntryName)) {
          this.updateMenuContent()
        }
      }
    }
  },
  created: function() {
    this.menuContentHolder = this.menuContent
    this.updateMenuContent()
  },
  methods: {
    stripSlashes: function(string) {
      return string.replace('/', '')
    },
    updateMenuContent: function() {
      let instance = this

      // Strip the menu down to a given entry point
      if (this.menuContainerEntryName && this.menuReduce && this.menuSelection !== 'auto') {
        if (this.menuContainerEntryName && this.menuSelection !== 'auto') {
          this.menuContent['Menu Items'].some(function(element, index) {
            if (element.linkText === instance.menuContainerEntryName) {
              instance.menuContentHolder = instance.menuContent['Menu Items'][index]

              // Stop at the first finding
              return true
            }
          })
        }
      }
      // For vertical menus that are automatically put into a page
      // @todo Refactor this function to be recursive
      else if (this.menuSelection === 'auto') {
        let elementFound = false

        this.menuContent['Menu Items'].some(function(element, index) {
          // Compare current URL with URL from menu items
          if (instance.stripSlashes(element.linkUrl) === instance.stripSlashes(instance.$route.path) && elementFound === false) {
            if (typeof instance.menuContent['Menu Items'][index].columns !== 'undefined') {
              instance.menuContentHolder = instance.menuContent['Menu Items'][index]
              elementFound = true
            }

            // Stop at the first finding
            return true
          }
          else if (typeof element.columns !== 'undefined' && element.columns.length > 0 && elementFound === false) {
            instance.menuContent['Menu Items'][index].columns.some(function(subElement, subIndex) {
              if (instance.stripSlashes(subElement.linkUrl) === instance.stripSlashes(instance.$route.path) && elementFound === false) {
                // Traverse back to the main parent after that
                instance.menuContentHolder = instance.menuContent['Menu Items'][index]
                elementFound = true

                // Stop at the first finding
                return true
              }
              else if (typeof subElement.columns !== 'undefined' && subElement.columns.length > 0 && elementFound === false) {
                subElement.columns.some(function(subSubElement, subSubIndex) {
                  if (instance.stripSlashes(subSubElement.linkUrl) === instance.stripSlashes(instance.$route.path) && elementFound === false) {
                    // Traverse back to the main parent after that
                    instance.menuContentHolder = instance.menuContent['Menu Items'][index]
                    elementFound = true

                    // Stop at the first finding
                    return true
                  }
                })
              }
              else {
                instance.menuContentHolder = null
              }
            })
          }
        })
        // Empty the menu if nothing has been found
        if (elementFound === false) {
          instance.menuContentHolder = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.mega-region-display {
  display:none;

  &.visible {
    display:flex;
  }
  @include media-breakpoint-up(md) {
    display:flex;
  }
}
</style>
